import type { NotificationDetailAction } from "./notificationDetailActions"
import { resolveNotificationInternalPath } from "./notificationDetailNavigation"

function pickStr(obj: Record<string, unknown>, keys: string[]): string | undefined {
  for (const k of keys) {
    const v = obj[k]
    if (typeof v === "string" && v.trim()) return v.trim()
  }
  return undefined
}

/** Platform updates / admin broadcasts — inbox category `announcement` or event key patterns. */
export function isAnnouncementDetailEventKey(
  eventKey: string | null | undefined,
  type?: string | null
): boolean {
  if (type === "announcement") return true
  if (!eventKey) return false
  return (
    eventKey === "announcement.platform" ||
    eventKey.startsWith("announcement.") ||
    eventKey.startsWith("broadcast.")
  )
}

/**
 * Optional CTA from admin/broadcast payload.
 * Prefers in-app paths; absolute APP_ORIGIN URLs are converted when possible.
 */
export function buildAnnouncementDetailActions(
  details: unknown
): NotificationDetailAction[] {
  if (!details || typeof details !== "object" || Array.isArray(details)) {
    return []
  }
  const obj = details as Record<string, unknown>
  const rawUrl = pickStr(obj, ["action_url", "actionUrl"])
  if (!rawUrl) return []

  const path = resolveNotificationInternalPath(rawUrl)
  if (!path || !path.startsWith("/")) return []

  const label =
    pickStr(obj, ["action_label", "actionLabel"]) || "Open"

  return [
    {
      id: "announcement-cta",
      rowLabel: "Update",
      buttonLabel: label,
      path,
    },
  ]
}
